import "./map.css";
const Map = () => {
  return (
    <>
      <section className="map">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3431.764165510198!2d76.73286817478935!3d30.668768774615227!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390febf895555517%3A0x2da730babbda8508!2sBest%20Deal%20Electricals!5e0!3m2!1sen!2sin!4v1748354741849!5m2!1sen!2sin"
          className="map"
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </section>
    </>
  );
};
export default Map;
